/**
 * OIDC start consent gate on Sign-in.
 *
 * Product: legal ticks are register-only. Sign-in never shows terms/privacy for
 * Google/Apple — POST start uses `intent: 'login'` so the API may omit consents.
 * Register still requires both checkboxes before start.
 * CONSENTS_REQUIRED recovery navigates to sign-up (never force-shows ticks here).
 */
export function shouldShowOidcStartConsents(_forceOidcConsentsOnce = false): boolean {
  return false;
}
